import { apiGet } from "./api-client";
import { API_BASE_URL } from "./api-base";
import { getSessionToken } from "./token-session";

const REGISTER_STATUS_URL = `${API_BASE_URL}/api/user/register_status`;

export function getHelpers() {
  return apiGet("/v1/api/helpers");
}

function readLang() {
  return localStorage.getItem("U_LANGUAGE") || "en-US";
}

function parseOk(json) {
  if (!json || typeof json !== "object") return false;
  const topCode = Number(json.code);
  if (topCode === 1 || topCode === 200) return true;

  if (json.data && typeof json.data === "object") {
    const subCode = Number(json.data.code);
    return subCode === 1 || subCode === 200;
  }

  return false;
}

async function postStatus(url, payload) {
  const token = getSessionToken();
  const resp = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept-Language": readLang(),
      Lang: readLang(),
      ...(token ? { token } : {}),
    },
    body: JSON.stringify(payload || {}),
  });

  if (!resp.ok) {
    throw new Error(`register_status HTTP ${resp.status}`);
  }

  const json = await resp.json();
  if (!parseOk(json)) {
    const msg = (json && (json.msg || json.message)) || "register_status failed";
    throw new Error(msg);
  }

  return json;
}

export async function registerStatus(payload = {}) {
  const body = {
    address:
      payload.address ||
      sessionStorage.getItem("ADDRESS") ||
      localStorage.getItem("U_ADDRESS") ||
      "",
    status: Number(payload.status || 1),
  };

  return postStatus(REGISTER_STATUS_URL, body);
}
